//import Immutable from 'immutable';
import { combineReducers } from "redux-immutable";

import loginReducer from "./loginReducer";

const rootReducer = combineReducers({
  login: loginReducer,
});

export default rootReducer;
